<template>
  <div>
    <kn-form-subtitle title="Agregar ciclo escolar" />
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-row>
        <v-col 
          class="pb-0" 
          cols="12"
          md="4"
          lg="4"
          xl="4">
          <v-subheader>Nombre ciclo escolar:</v-subheader>
        </v-col>
        <v-col class="pb-0">
          <v-text-field
            v-model="schoolCycle.dato"
            dense
            outlined
            :rules="[rules.required]"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col 
          class="py-0" 
          cols="12"
          md="4"
          lg="4"
          xl="4"
        >
          <v-subheader>Fecha inicio:</v-subheader>
        </v-col>
        <v-col 
          class="py-0" 
          cols="12"
          md="4"
          lg="8"
          xl="4"
        >
          <v-text-field
            v-model="schoolCycle.fecha_inicio"
            dense
            outlined
            :rules="[rules.required]"
            type="date"
            hint="DD / MM / YYYY"
            persistent-hint
          >
            <template v-slot:append-outer>
              <v-icon color="primary">mdi-calendar-month-outline</v-icon>
            </template>
          </v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col 
          class="py-0" 
          cols="12"
          md="4"
          lg="4"
          xl="4"
        >
          <v-subheader>Fecha fin:</v-subheader>
        </v-col>
        <v-col 
          class="py-0" 
          cols="12"
          md="4"
          lg="8"
          xl="4"
        >
          <v-text-field
            v-model="schoolCycle.fecha_fin"
            dense
            outlined
            :rules="[rules.required]"
            type="date"
            hint="DD / MM / YYYY"
            persistent-hint
          >
            <template v-slot:append-outer>
              <v-icon color="primary">mdi-calendar-month-outline</v-icon>
            </template>
          </v-text-field>
        </v-col>
      </v-row>
      <kn-form-action-buttons
        class="mb-14"
        :small="true"
        :disableAccept="invalidFields"
        @accept="save"
        @cancel="clear"
      />
    </v-form>
    <kn-form-subtitle
      title="Listado de ciclos escolares"
      divider-position="bottom"
    />
    <v-list two-line>
      <v-list-item-group>
        <template v-for="(item, index) in activeSchoolCycles">
          <v-list-item :key="item.nombre_salon">
              <v-list-item-content>
                <v-text-field
                  v-if="toUpdate && item.id === schoolCycle.id"
                  class="mb-0 pb-0"
                  v-model="schoolCycle.dato"
                  dense
                  outlined
                />
                <v-list-item-title
                  v-else
                  class="purple--text"
                  v-text="item.dato"
                />
                <v-text-field
                  v-if="toUpdate && item.id === schoolCycle.id"
                  v-model="schoolCycle.fecha_inicio"
                  dense
                  outlined
                  type="date"
                  hint="DD / MM / YYYY"
                  persistent-hint
                >
                  <template v-slot:append-outer>
                    <v-icon color="primary">mdi-calendar-month-outline</v-icon>
                  </template>
                </v-text-field>
                <v-list-item-subtitle
                  v-else
                  class="text--primary"
                  v-text="`Inicio: ${item.fecha_inicio}`"
                />
                <v-text-field
                  v-if="toUpdate && item.id === schoolCycle.id"
                  v-model="schoolCycle.fecha_fin"
                  dense
                  outlined
                  type="date"
                  hint="DD / MM / YYYY"
                  persistent-hint
                >
                  <template v-slot:append-outer>
                    <v-icon color="primary">mdi-calendar-month-outline</v-icon>
                  </template>
                </v-text-field>
                <v-list-item-subtitle
                  v-else
                  class="text--primary"
                  v-text="`Fin: ${item.fecha_fin}`"
                />
              </v-list-item-content>

              <v-list-item-action>
                <v-row
                  v-if="toUpdate && item.id === schoolCycle.id"
                  no-gutters
                  align="start"
                >
                  <v-col>
                    <v-btn
                      icon
                      color=primary
                      @click="clearInline"
                      title="Cancelar"
                    >
                      <v-icon color="primary">
                        mdi-cancel
                      </v-icon>
                    </v-btn>
                  </v-col>
                  <v-col>
                    <v-btn
                      icon
                      color=primary
                      @click="save"
                      title="Guardar cambios"
                    >
                      <v-icon color="primary">
                        mdi-content-save-outline
                      </v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row
                  v-else
                  no-gutters
                >
                  <v-col>
                    <v-btn
                      icon
                      color=primary
                      @click="edit(item)"
                      title="Editar"
                    >
                      <v-icon color="primary">
                        mdi-pencil-outline
                      </v-icon>
                    </v-btn>
                  </v-col>
                  <v-col>
                    <v-btn
                      icon
                      color=primary
                      @click="deleteInline(item.id)"
                      title="Eliminar"
                    >
                      <v-icon color="primary">
                        mdi-trash-can-outline
                      </v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-list-item-action>
          </v-list-item>

          <v-divider
            v-if="index < activeSchoolCycles.length - 1"
            :key="index"
          ></v-divider>
        </template>
      </v-list-item-group>
    </v-list>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { api } from '@/api/axios-base'
import { validationFormMixin } from '@/mixins/validationFormMixin'
export default {
  components: {
    KnFormSubtitle: () => import('@/components/KnFormSubtitle.vue'), 
    KnFormActionButtons: () => import('@/components/KnFormActionButtons.vue') 
  },
  mixins: [validationFormMixin],
  data() {
    return {
      errors: [],
      valid: true,
      schoolCycle: {
        id: 'NA', // No asignado
        dato: null,
        fecha_inicio: null,
        fecha_fin: null,
        id_autor: null,
        id_institucion_educativa: null
      },
      schoolCycles: [],
      toUpdate: false
    }
  },
  computed: {
    ...mapState(['institutionId', 'userData']),
    actionTitle() {
      return this.toUpdate ? 'Actualizar' : 'Crear'
    },
    activeSchoolCycles() {
      return this.schoolCycles.filter(schoolCycle => schoolCycle.estatus_sistema === true)
    },
    invalidFields() {
      return this.objectHasNulls(this.schoolCycle)
    }
  },
  async created() {
    this.schoolCycle.id_autor = this.userData.id
    this.schoolCycle.id_institucion_educativa = this.institutionId
    this.schoolCycles = await this.fetchSchoolCycles(this.institutionId)
  },
  methods: {
    async fetchSchoolCycles() {
      try {
        const response = await api.get('/personas/api/ciclo-escolar-all/')
        const responseData = await response.data
        return responseData
      } catch (error) {
        console.error('Error al intentar obtener ciclo escolar', error);
      }
    },
    async createSchoolCycle() {
      try {
        const response = await api.post('/personas/crear-ciclo-escolar', {
          nombre_ciclo_escolar: this.schoolCycle.dato,
          fecha_inicio: this.schoolCycle.fecha_inicio,
          fecha_fin: this.schoolCycle.fecha_fin,
          id_institucion_educativa: this.schoolCycle.id_institucion_educativa
        })
        const responseData = await response.data
        if (responseData.e) {
          this.errors.push('Ocurrió un error, no se pudo crear el ciclo escolar.')
        }
      } catch (error) {
        console.error('Error al intentar crear el ciclo escolar', error)
        this.errors.push('Error al intentar crear el ciclo escolar')
      }
    },
    async updateSchoolCycle() {
      try {
        const response = await api.patch('/personas/update-ciclo-escolar', {
          id: this.schoolCycle.id,
          dato: this.schoolCycle.dato,
          fecha_inicio: this.schoolCycle.fecha_inicio,
          fecha_fin: this.schoolCycle.fecha_fin
        })
        const responseData = await response.data
        if (responseData.e) {
          this.errors.push('Ocurrió un error, no se pudo actualizar el ciclo escolar')
        }
      } catch (error) {
        console.error('Error al intentar actualizar el ciclo escolar', error);
      }
    },
    // Los deletes no eliminan los registros, cambian el estatus a False
    async deleteSchoolCycle(schoolCycleId) {
      try {
        const response = await api.post('/personas/delete-ciclo-escolar', {
          id_ciclo_escolar: schoolCycleId
        })
        const responseData = await response.data
        if (responseData.e) {
          this.errors.push('Ocurrió un error, no se pudo eliminar el ciclo escolar')
        }
      } catch (error) {
        console.error('Error al intentar eliminar el ciclo escolar', error);
      }
    },
    async save() {
      if (this.toUpdate) {
        await this.updateSchoolCycle()
        this.toUpdate = false
      } else {
        await this.createSchoolCycle()
        this.clear()
      }
      this.schoolCycles = await this.fetchSchoolCycles(this.institutionId)
      this.clear()
    },
    clear() {
      this.schoolCycle = {
        id: 'NA', // No asignado
        dato: null,
        fecha_inicio: null,
        fecha_fin: null,
        id_autor: this.userData.id,
        id_institucion_educativa: this.institutionId 
      }
      this.toUpdate = false
      this.$refs.form.resetValidation()
    },
    clearInline() {
      this.schoolCycle = {
        id: 'NA', // No asignado
        dato: null,
        fecha_inicio: null,
        fecha_fin: null,
        id_autor: this.userData.id,
        id_institucion_educativa: this.institutionId 
      }
      this.toUpdate = false
      this.$refs.form.resetValidation()
    },
    edit(item) {
      this.schoolCycle = {...item}
      // console.log('Item a editar:', this.schoolCycle);
      this.toUpdate = true
    },
    async deleteInline(itemId) {
      await this.deleteSchoolCycle(itemId)
      this.schoolCycles = await this.fetchSchoolCycles(this.institutionId)
      this.clearInline()
    }
  },
}
</script>

<style>

</style>